import React from 'react';
import PropTypes from 'prop-types';
import HeadingAlpha from '../headings/heading-alpha';
import InfoBlock from '../texts/info-block';
import ReactMarkdown from 'react-markdown';

// react-markdown
const CustomModalContent = props => (
  <div className='modal-main'>
    <HeadingAlpha className='bottom-space'>{props.title}</HeadingAlpha>
    <InfoBlock>
      {props.isRichText ? (
        <ReactMarkdown source={props.content} />
      ) : (
        props.content
      )}
    </InfoBlock>
  </div>
);

CustomModalContent.propTypes = {
  title: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  isRichText: PropTypes.bool
};

export default CustomModalContent;



// WEBPACK FOOTER //
// ./src/ui/views/custom-modal-content.js